import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { FiFacebook, FiTwitter, FiInstagram, FiLinkedin } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-nukki-dark text-white py-5">
      <Container fluid style={{ maxWidth: '1400px' }}>
        <Row className="g-4">
          <Col lg={3} md={6}>
            <img
              src="/logos/Prancheta 1_2.svg"
              alt="Nukki"
              height="45"
              className="mb-3"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
            <p className="text-white mb-3">
              {t('footer.tagline')}
            </p>
            <div className="d-flex gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-none fs-5 hover-secondary">
                <FiFacebook />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-none fs-5 hover-secondary">
                <FiTwitter />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-none fs-5 hover-secondary">
                <FiInstagram />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-none fs-5 hover-secondary">
                <FiLinkedin />
              </a>
            </div>
          </Col>

          <Col lg={3} md={6}>
            <h4 className="h6 fw-semibold mb-3 text-white">{t('footer.support')}</h4>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/help" className="text-white text-decoration-none hover-white">
                  {t('footer.helpCenter')}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/safety" className="text-white text-decoration-none hover-white">
                  {t('footer.safety')}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/cancellation" className="text-white text-decoration-none hover-white">
                  {t('footer.cancellation')}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/covid" className="text-white text-decoration-none hover-white">
                  {t('footer.covid')}
                </Link>
              </li>
            </ul>
          </Col>

          <Col lg={3} md={6}>
            <h4 className="h6 fw-semibold mb-3 text-white">{t('footer.hosting')}</h4>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/host" className="text-white text-decoration-none hover-white">
                  {t('footer.becomeHost')}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/host/resources" className="text-white text-decoration-none hover-white">
                  {t('footer.hostResources')}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/host/community" className="text-white text-decoration-none hover-white">
                  {t('footer.communityForum')}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/host/responsible" className="text-white text-decoration-none hover-white">
                  {t('footer.responsibleHosting')}
                </Link>
              </li>
            </ul>
          </Col>

          <Col lg={3} md={6}>
            <h4 className="h6 fw-semibold mb-3 text-white">{t('footer.company')}</h4>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/about" className="text-white text-decoration-none hover-white">
                  {t('footer.aboutUs')}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/careers" className="text-white text-decoration-none hover-white">
                  {t('footer.careers')}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/press" className="text-white text-decoration-none hover-white">
                  {t('footer.press')}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/investors" className="text-white text-decoration-none hover-white">
                  {t('footer.investors')}
                </Link>
              </li>
            </ul>
          </Col>
        </Row>

        <hr className="my-4 border-secondary opacity-25" />

        <Row className="align-items-center">
          <Col md={6} className="text-center text-md-start mb-3 mb-md-0">
            <p className="text-white mb-0">
              &copy; {new Date().getFullYear()} Nukki. {t('footer.rights')}
            </p>
          </Col>
          <Col md={6} className="text-center text-md-end">
            <div className="d-flex justify-content-center justify-content-md-end gap-3 align-items-center">
              <Link to="/privacy" className="text-white text-decoration-none hover-white">
                {t('footer.privacy')}
              </Link>
              <span className="text-white">·</span>
              <Link to="/terms" className="text-white text-decoration-none hover-white">
                {t('footer.terms')}
              </Link>
              <span className="text-white">·</span>
              <Link to="/sitemap" className="text-white text-decoration-none hover-white">
                {t('footer.sitemap')}
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
